import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isUndefined from 'lodash/isUndefined';
import { Slider } from 'antd';
import numeral from 'numeral';
import { updateSearchFilters as update, clearSearchFilters as clear } from '../../../../actions';
import ClearButton from '../ClearButton';

const PriceSlider = () => {
  const dispatch = useDispatch();

  const {
    parameters: {
      daily_price_gteq: dailyPriceGteq,
      daily_price_lteq: dailyPriceLteq,
    },
  } = useSelector((state) => state.searchFilters);

  const {
    locale: {
      search: {
        price_max: maxPrice,
      },
      currency,
      locale,
    },
  } = useSelector((state) => state.searchResults);

  const [currentSliderPriceGteq, setCurrentSliderPriceGteq] = useState((dailyPriceGteq / 100));
  const [currentSliderPriceLteq, setCurrentSliderPriceLteq] = useState((dailyPriceLteq / 100));
  const [filterCleared, setFilterCleared] = useState(false);
  const [formattedPriceLteq, setFormattedPriceLteq] = useState('');
  const [formattedPriceGteq, setFormattedPriceGteq] = useState('');

  useEffect(() => {
    if (filterCleared || (isUndefined(dailyPriceLteq) && isUndefined(dailyPriceGteq))) {
      setCurrentSliderPriceGteq(0);
      setCurrentSliderPriceLteq(maxPrice / 100);
      setFilterCleared(false);
    } else if (isUndefined(dailyPriceLteq)) {
      setCurrentSliderPriceLteq(maxPrice / 100);
      setCurrentSliderPriceGteq((dailyPriceGteq / 100));
    } else if (isUndefined(dailyPriceGteq)) {
      setCurrentSliderPriceGteq(0);
      setCurrentSliderPriceLteq((dailyPriceLteq / 100));
    } else {
      setCurrentSliderPriceGteq((dailyPriceGteq / 100));
      setCurrentSliderPriceLteq((dailyPriceLteq / 100));
    }
  }, [filterCleared, dailyPriceLteq, dailyPriceGteq, maxPrice]);

  useEffect(() => {
    const formattedLteq = numeral(currentSliderPriceLteq).format();
    let displayLteq = currency
      .format
      .replace('%u', currency.unit)
      .replace('%n', formattedLteq);

    if (currentSliderPriceLteq === (maxPrice / 100)) {
      displayLteq += '+';
    }

    const formattedGteq = numeral(currentSliderPriceGteq).format();
    const displayGteq = currency
      .format
      .replace('%u', currency.unit)
      .replace('%n', formattedGteq);

    setFormattedPriceGteq(displayGteq);
    setFormattedPriceLteq(displayLteq);
  }, [currency.format, currency.unit, currentSliderPriceGteq, currentSliderPriceLteq, locale, maxPrice]);

  const resetFilter = () => {
    dispatch(clear(['daily_price_lteq', 'daily_price_gteq']));
    setCurrentSliderPriceLteq(maxPrice / 100);
    setFilterCleared(true);
  };

  return (
    <div className="price-slider-container">
      <Slider
        range
        className="price-slider"
        value={[currentSliderPriceGteq, currentSliderPriceLteq]}
        tooltip={{ formatter: null }}
        max={(maxPrice / 100)}
        onChange={([gteq, lteq]) => {
          setCurrentSliderPriceGteq(gteq);
          setCurrentSliderPriceLteq(lteq);
        }}
        onAfterChange={([gteq, lteq]) => {
          const payload = {};

          if (gteq !== 0) {
            payload.daily_price_gteq = gteq * 100;
          } else {
            dispatch(clear(['daily_price_gteq']));
          }

          if (lteq !== (maxPrice / 100)) {
            payload.daily_price_lteq = lteq * 100;
          } else {
            dispatch(clear(['daily_price_lteq']));
          }

          if (payload.daily_price_gteq || payload.daily_price_lteq) {
            dispatch(update(payload));
          } else {
            resetFilter();
          }
        }}
      />
      <div className="filter-price-subtitles clearfix">
        <span className="pull-left price-subtitle">{formattedPriceGteq}</span>
        <span className="pull-right price-subtitle">{formattedPriceLteq}</span>
      </div>
      <ClearButton onClick={resetFilter} />
    </div>
  );
};

export default PriceSlider;
